"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPolygonButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function EditPolygonButtons({ onEmptyClick, onAddShapeClick, allowMultipolygon = true }) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            margin: 10,
            position: "absolute",
            bottom: 0,
            display: "flex",
            flexDirection: "row",
            gap: 10,
            pointerEvents: "auto"
        }, children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary", onClick: onEmptyClick, children: "Za\u010D\u00EDt znovu" }), allowMultipolygon && (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-light", onClick: onAddShapeClick, children: "Dal\u0161\u00ED tvar" })] }));
}
exports.EditPolygonButtons = EditPolygonButtons;
